export class AgrupadorDocumentos {
  title: {
    rendered: string,
  };
  author: {
    id: number,
    name: string,
  };
  id: number;
  date: Date;
  slug: string;

  documentos: Documento[];

  constructor(args) {
    Object.assign(this, args);
  }
}

export class Documento {
  title: string;
  file: {
    url: string,
    type: string,
    error: boolean,
  };

  constructor(args) {
    Object.assign(this, args);
  }
}
